// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/modules/components/elements/offers.less
// module id = 404
// module chunks = 0